/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  var timestamp = 0;
  var threshold = 1000 / freq;
  var lastArgs;
  var timer;

  var invoke = function invoke(args) {
    var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    timestamp = now;
    lastArgs = null;

    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    fn.apply(null, args);
  };

  var throttled = function throttled() {
    var now = Date.now();
    var passed = now - timestamp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;

      if (!timer) {
        timer = setTimeout(function () {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  var flush = function flush() {
    return lastArgs && invoke(lastArgs);
  };

  return [throttled, flush];
}

export default throttle;